import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from '../components/Logo';

const OAuthCallback = ({ onAuthComplete }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState('Processing authentication...');
  const [error, setError] = useState('');
  const [successfulAuth, setSuccessfulAuth] = useState(false);
  const [readyToRedirect, setReadyToRedirect] = useState(false);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(location.search);
        const authData = urlParams.get('data');

        if (!authData) {
          setError('No authentication data received');
          return;
        }

        setStatus('Processing authentication data...');

        try {
          const payload = JSON.parse(atob(authData));

          if (payload.success && payload.user) {
            localStorage.setItem('user', JSON.stringify(payload.user));
            localStorage.setItem('isAuthenticated', 'true');
            
            setStatus('Authentication successful! Redirecting...');
            setSuccessfulAuth(true);
            
            if (onAuthComplete) {
              try {
                // Wait for the auth complete handler to finish updating state
                await onAuthComplete();
              } catch (error) {
                console.error('Error in onAuthComplete:', error);
              }
            }
            
            // Longer delay to ensure React state updates are complete
            setTimeout(() => {
              setReadyToRedirect(true);
            }, 100);
            
          } else if (payload.error === 'not_in_database' && payload.user) {
            // User authenticated but not in database - store limited user data and redirect
            localStorage.setItem('user', JSON.stringify(payload.user));
            localStorage.setItem('isAuthenticated', 'partial'); // Mark as partial auth
            
            setStatus('Redirecting to account setup...');
            setTimeout(() => {
              navigate('/not-in-database', { replace: true });
            }, 100);
            
          } else {
            setError(payload.error || 'Authentication failed');
          }
        } catch (decodeError) {
          console.error('Error decoding auth data:', decodeError);
          setError('Invalid authentication data format');
        }
      } catch (err) {
        console.error('OAuth callback error:', err);
        setError('Failed to process authentication');
      }
    };

    handleCallback();
  }, [navigate, location, onAuthComplete]);

  if (readyToRedirect) {
    window.location.replace('/dashboard/#home');
    return null;
  }

  return (
    <div className="landing-container">
      <div className="landing-content">
        <Logo size={150} className="landing-logo" />
        <h1 className="landing-title">Symbolica</h1>
        
        {error ? (
          <div style={{
            background: '#fef2f2',
            color: '#dc2626',
            padding: '16px',
            borderRadius: '8px',
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            <h3 style={{ marginBottom: '8px' }}>Authentication Error</h3>
            <p>{error}</p>
            <button
              onClick={() => navigate('/')}
              style={{
                background: '#dc2626',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
                marginTop: '12px'
              }}
            >
              Try Again
            </button>
          </div>
        ) : (
          <div style={{
            background: '#f0fdf4',
            color: '#16a34a',
            padding: '16px',
            borderRadius: '8px',
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            <h3 style={{ marginBottom: '8px' }}>Authenticating...</h3>
            <p>{status}</p>
            <div style={{
              width: '20px',
              height: '20px',
              border: '2px solid #16a34a',
              borderTop: '2px solid transparent',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '12px auto 0'
            }}></div>
          </div>
        )}
      </div>
      
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default OAuthCallback; 